module.exports = __webpack_public_path__ + "img/pic-a-2.png";